import moment from 'moment';

import { Moment } from '../../../typings/globals/sam';
import { OptionLicense } from './option-licence.model';
import { UserLicense } from './user-licence.model';

export class TenantLicense {
  public tenant: string;
  public tenantName: string;
  public fullUserLicensesCount: number;
  public expirationDate: Moment;
  public status: string;
  public optionList: OptionLicense[] | undefined;
  public optionListNames: string[] | undefined;
  public registeredLicenseUsers: UserLicense[] | undefined;

  // tslint:disable-next-line: cyclomatic-complexity
  constructor(data: Partial<TenantLicense> = {}) {
    this.tenant = data.tenant?.toLowerCase() ?? '';
    this.tenantName = data.tenantName ?? '';
    this.fullUserLicensesCount = data.fullUserLicensesCount ?? 0;
    this.expirationDate = data.expirationDate
      ? moment(data.expirationDate)
      : moment();
    this.status = data.status ?? 'ACTIVE';
    this.optionList = data.optionList ?? [];
    this.optionListNames = data.optionListNames ?? [];
    this.registeredLicenseUsers = data.registeredLicenseUsers ?? [];
  }

  /**
   * Make sure that the tenant id is in lowercase
   *
   * @static
   * @param {TenantLicense} tenant
   */
  public static format(tenant: TenantLicense): TenantLicense {
    tenant.tenant = tenant.tenant?.toLowerCase() ?? '';
    return tenant;
  }
}
